import * as types from './types';

const getPostingData = idPost => {
  return {
    type: types.GET_POSTING_INFO,
    meta: {
      async: true,
      blocking: false,
      api: 'publicadorProf',
      path: `/publication/api/v1/posting/edit/${idPost}`,
      method: 'GET'
    }
  };
};

const getQualityData = idPost => {
  return {
    type: types.GET_QUALITY_INFO,
    meta: {
      async: true,
      blocking: false,
      api: 'publicadorProf',
      path: `/publication/api/v1/performance/getQualityTips/${idPost}`,
      method: 'GET'
    }
  };
};

const setLoading = needShowLoader => {
  return {
    type: types.SET_LOADING,
    payload: {
      needShowLoader
    }
  };
};

export { getPostingData, getQualityData, setLoading };
